import {InfoModuleFreeSpinsState} from '@fantasmagames/slot/src/modules/hud/info/states/InfoModuleFreeSpinsState';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {RecodeInfoModule} from '@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';

export class RecodeInfoModuleFreeSpinsState extends InfoModuleFreeSpinsState {
	public onLeaveState(): void {
		super.onLeaveState();
		(this.module as RecodeInfoModule).spinCumulativeWins = 0;
	}

	public onEnterState(): void {
		super.onEnterState();

		const logic: RecodeLogic = this.module.logic as RecodeLogic;

		if (this.module.logic.freeSpinsPlayed === 0) {
			(this.module as RecodeInfoModule).spinCumulativeWins = 0;
		} else {
			(this.module as RecodeInfoModule).spinCumulativeWins = logic.getTransTotalWin() - this.module.logic.getWin();
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
	}

	protected onSpinResponse(): void {}

	protected onNoWin(): void {}

	protected onBigWinFinished(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;
		const win = logic.getTransTotalWin();

		// this.updateBalance(this.module.logic.currentBalance); should not update balance in free spins
		this.updateWin(win);
	}

	protected onInitResponse(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;
		const newBalance = Math.max(0, this.module.logic.currentBalance - logic.getTransTotalWin());

		if (this.module.logic.hasRestore) {
			this.updateBalance(newBalance);
		} else {
			this.updateBalance(newBalance);
			this.updateWin(logic.getTransTotalWin());
		}
		this.updateBet();
	}

	protected onWinNumberShownToPlayer(): void {
		const logic: RecodeLogic = this.module.logic as RecodeLogic;
		const win = logic.getTransTotalWin();

		this.updateWin(win);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/recode/states/RecodeInfoModuleFreeSpinsState.ts